import React from 'react';
import './Card.css';
import { Link } from 'react-router-dom';

export default function Card ({min, max, name, img, onClose, id, flag}) {
    
  const estilo = {
    'text-decoration': 'none'
  }
  
    return (
      <div className="card">
        <div id="closeIcon" className="row">
            <img src={flag} alt='bandera' className='bandera'/>
            <button onClick={onClose} className="btn btn-sm btn-danger">X</button>
        </div>

        <Link to={`/ciudad/${id}`} style={estilo}>
        <div className="card-body">
          <h5 className="card-title">{name}</h5>
          <div className="row">
            <div className="col-sm-4 col-md-4 col-lg-4">
              <p>Min</p>
              <p>{min}°</p>
            </div>
            <div className="col-sm-4 col-md-4 col-lg-4">
              <p>Max</p>
              <p>{max}°</p>
            </div>
            <div className="col-sm-4 col-md-4 col-lg-4">
              <img className="iconoClima" src={"http://openweathermap.org/img/wn/"+img+"@2x.png"} width="80" height="80" alt="" />
            </div>
          </div>
        </div>
        </Link>
        
      </div>
    );
};
